<template>
    <div>
        <v-dialog persistent v-model="showArticleModal" scrollable :max-width="Global.MODAL_WIDTH">
            <!--<v-btn v-if="!onlyTrashed" slot="activator" fab dark small color="primary">-->
                <!--<v-icon dark>add</v-icon>-->
            <!--</v-btn>-->
            <v-card>
                <v-card-title class="mb-0, pb-0">
                    <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text class="mx-0, px-0">
                    <v-tabs
                        color="blue-grey darken-2 white--text"
                        dark
                        slider-color="blue-grey darken-1"
                        grow
                    >
                    <v-tab ripple>Geral</v-tab>
                    <v-tab-item>

                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 sm6 md4 px-2>
                                        <v-text-field v-model="formArticle.name"
                                            :counter="$v.formArticle.name.$params.maxLength.max"
                                            :error-messages="nameErrors"
                                            @blur="$v.formArticle.name.$touch()"
                                            :disabled="articleShow"
                                            label="Nome*"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4 px-2>
                                        <v-select v-model="formArticle.types_id"
                                            item-text="name"
                                            item-value="id"
                                            :error-messages="articleTypeErrors"
                                            @blur="$v.formArticle.types_id.$touch()"
                                            @input="onArticleTypeChanged"
                                            :disabled="articleShow"
                                            :items="article_types" label="Tipo de artigo*"></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4 px-2>
                                        <v-text-field type="number" v-model="formArticle.price"
                                            :error-messages="priceErrors"
                                            @blur="$v.formArticle.price.$touch()"
                                            :disabled="articleShow"
                                            label="Preço com taxa*"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4 px-2>
                                        <v-select v-model="formArticle.active_state"
                                            :color="formArticle.active_state ? 'green' : 'red'"
                                            item-text="name"
                                            item-value="id"
                                            :error-messages="activeStateErrors"
                                            @blur="$v.formArticle.active_state.$touch()"
                                            :disabled="articleShow"
                                            :items="active_states" label="Estado*"></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4 px-2>
                                        <v-select v-model="formArticle.unity"
                                            :disabled="articleShow || isService()"
                                            :items="unities" label="Unidade"></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4 px-2>
                                        <v-text-field type="number"
                                            v-model="formArticle.stock"
                                            :error-messages="stockErrors"
                                            @blur="$v.formArticle.stock.$touch()"
                                            :disabled="articleShow || isService()"
                                            label="Stock"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4 px-2>
                                        <v-text-field type="number"
                                            v-model="formArticle.min_stock"
                                            :error-messages="minStockErrors"
                                            @blur="$v.formArticle.min_stock.$touch()"
                                            :disabled="articleShow || isService()"
                                            label="Min. Stock"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4 px-2>
                                        <v-combobox
                                            v-model.number="formArticle.category"
                                            :items="categories"
                                            item-text="name"
                                            item-value="id"
                                            :disabled="articleShow"
                                            :small-chips="!!formArticle.category && !!formArticle.category.id"
                                            label="Categoria"
                                        ></v-combobox>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4 px-2>
                                        <v-combobox
                                            v-model="formArticle.subcategory"
                                            :items="subcategories"
                                            item-text="name"
                                            item-value="id"
                                            :disabled="articleShow"
                                            :small-chips="!!formArticle.subcategory && !!formArticle.subcategory.id"
                                            label="Subcategoria"
                                        ></v-combobox>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4 px-2>
                                        <v-text-field v-model="formArticle.bar_code"
                                            :counter="$v.formArticle.bar_code.$params.maxLength.max"
                                            :error-messages="barCodeErrors"
                                            @blur="$v.formArticle.bar_code.$touch()"
                                            :disabled="articleShow"
                                            label="Código de barra"></v-text-field>
                                    </v-flex>

                                    <!-- <v-flex xs12 sm12 md12 px-2>
                                        <v-autocomplete
                                            v-if="isLoggedUserSuperAdmin"
                                            v-model="formArticle.companies_id"
                                            :error-messages="companyErrors"
                                            :disabled="articleShow"
                                            @blur="$v.formArticle.companies_id.$touch()"
                                            :items="companies"
                                            :loading="isLoading"
                                            no-data-text="..."
                                            :search-input.sync="searchCompanyField"
                                            chips
                                            clearable
                                            deletable-chips
                                            hide-selected
                                            item-text="name"
                                            item-value="id"
                                            label="Digite para procurar empresas..."
                                            solo
                                        >
                                            <template slot="selection" slot-scope="{ item, selected }">
                                                <v-chip :selected="selected" color="blue-grey" class="white--text" >
                                                    <v-icon left>mdi-coin</v-icon>
                                                    <span v-text="item.name"></span>
                                                </v-chip>
                                            </template>
                                            <template slot="item" slot-scope="{ item }">
                                                <v-list-tile-avatar
                                                    :color="'indigo'"
                                                    class="headline font-weight-light white--text"
                                                >
                                                    {{ item.id === -1 ? '+' : item.name.charAt(0) }}
                                                </v-list-tile-avatar>
                                                <v-list-tile-content>
                                                    <v-list-tile-title v-text="item.name"></v-list-tile-title>
                                                    <v-list-tile-sub-title v-text="item.symbol"></v-list-tile-sub-title>
                                                </v-list-tile-content>
                                                <v-list-tile-action>
                                                    <v-icon>mdi-coin</v-icon>
                                                </v-list-tile-action>
                                            </template>
                                        </v-autocomplete>
                                    </v-flex> -->

                                    <v-flex xs12 sm12 md12 px-2>
                                        <v-textarea v-model="formArticle.description"
                                            solo
                                            :error-messages="descriptionErrors"
                                            @blur="$v.formArticle.description.$touch()"
                                            :counter="$v.formArticle.description.$params.maxLength.max"
                                            :disabled="articleShow"
                                            label="Descrição" ></v-textarea>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                            </v-tab-item>
                            </v-tabs>

                </v-card-text>
                <br>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div v-if="!loading_modal">
                        <v-btn depressed @click="close">Cancelar</v-btn>
                        <v-btn v-if="!articleShow" :disabled="$v.$invalid" color="primary" @click="save">Guardar</v-btn>
                    </div>
                    <v-progress-circular v-else indeterminate color="primary" m-2 ></v-progress-circular>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
    import Vue from 'vue';
    import _ from 'lodash';
    import {required, requiredIf, minValue, minLength, maxLength} from 'vuelidate/lib/validators'
    import {mapGetters} from 'vuex';
    import {Model, Types, Global} from "../../config";

    export default {
        name: 'article_form_modal',

        data(){
            return {
                Global,
                loading_modal: false,
                companies: [], //list of companeis used in auto complete field (this is querried at the moment)

                //company form modal needed attributes
                company_types: [],
                company_categories: [],
                // canCloseIfClickOutside: false,

                //AutoComplete
                isLoading: false,
                searchCompanyField: null,
                countries: [],
                cities: [],
                unities: ['unit', 'metroQuadrado', 'metroCubico', 'litro', 'kilograma', 'grama', 'pacote', 'caixa', 'garrafa', 'embalagem'],
            }

        },


        props:{
            article_types: Array,
            active_states: Array,
            categories: Array,
            subcategories: Array,
        },

        watch: {
            selectedArticle(){
                this.consoleLog('selectedArticle change detected');
                setTimeout(()=>{
                    try{
                        this.searchCompanyField = this.selectedArticle.company_name;
                    }catch (e) {
                        //does nothing
                    }
                }, 100);

            },

            searchCompanyField (){
                this.searchCompany(this);
            },

            showArticleModal(){
                if(this.showArticleModal){
                    this.onArticleFormOpened();
                }
            },
        },

        validations: {
            formArticle: {
                name: {
                    required,
                    minLength: minLength(2),
                    maxLength: maxLength(100),
                },
                // companies_id: {
                //     required: requiredIf(function (nestedModel) {
                //         return this.isLoggedUserSuperAdmin;
                //     })
                // },
                types_id: {
                    required,
                },
                bar_code: {
                    maxLength: maxLength(100),
                },
                price: {
                    required,
                    minValue: minValue(0),
                },
                active_state: {
                    required,
                },
                stock: {
                    minValue: minValue(0),
                },
                min_stock: {
                    minValue: minValue(0),
                },
                description: {
                    maxLength: maxLength(250),
                }
            }
        },


        computed: {
            ...mapGetters([
                'getNewArticle',
                'loggedUser',
                'isLoggedUserSuperAdmin',
                'getToken'
            ]),

            showArticleModal: {
                get(){
                    return this.$store.getters.getShowArticleModal;
                },
                set(value){
                    this.$store.dispatch('setShowArticleModal', value);
                }
            },
            selectedArticle: {
                get(){
                    return this.$store.getters.getSelectedArticle;
                },
                set(value){
                    this.$store.dispatch('setSelectedArticle', value);
                }
            },
            formArticle: {
                get(){
                    return this.$store.getters.getFormArticle;
                },
                set(value){
                    this.$store.dispatch('setFormArticle', value);
                }
            },
            selectedCompany: {
                get(){
                    return this.$store.getters.getSelectedCompany;
                },
                set(value){
                    this.$store.dispatch('setSelectedCompany', value);
                }
            },
            articleShow: {
                get(){
                    return this.$store.getters.getArticleShow;
                },
                set(value){
                    this.$store.dispatch('setArticleShow', value);
                }
            },
            // canCloseIfClickOutside(){
            //     return this.showArticleModal && this.articleShow;
            // },
            formTitle () {
                return this.articleShow? 'Artigo' : (this.formArticle.id ? 'Editar Artigo' : 'Novo Artigo');
            },
            nameErrors () {
                const errors = [];
                if (!this.$v.formArticle.name.$dirty) return errors;
                // !this.$v.name.decimal && errors.push('Name must be a number')
                !this.$v.formArticle.name.minLength && errors.push('Minino de 2 caracteres');
                !this.$v.formArticle.name.maxLength && errors.push('Máximo de 30 caracteres');
                !this.$v.formArticle.name.required && errors.push('Digite um nome');
                return errors;
            },
            // companyErrors () {
            //     const errors = [];
            //     if (!this.$v.formArticle.companies_id.$dirty) return errors;
            //     !this.$v.formArticle.companies_id.required && errors.push('Escolha uma empresa');
            //     return errors
            // },
            articleTypeErrors () {
                const errors = [];
                if (!this.$v.formArticle.types_id.$dirty) return errors;
                !this.$v.formArticle.types_id.required && errors.push('Qual tipo?');
                return errors;
            },
            barCodeErrors () {
                const errors = [];
                if (!this.$v.formArticle.bar_code.$dirty) return errors;
                !this.$v.formArticle.bar_code.maxLength && errors.push('Máximo 100');
                return errors;
            },
            priceErrors () {
                const errors = [];
                if (!this.$v.formArticle.price.$dirty) return errors;
                !this.$v.formArticle.price.minValue && errors.push('Introduza valores não negativos');
                !this.$v.formArticle.price.required && errors.push('Escolha um preço.');
                return errors
            },
            activeStateErrors () {
                const errors = [];
                if (!this.$v.formArticle.active_state.$dirty) return errors;
                !this.$v.formArticle.active_state.required && errors.push('Escolha um estado.');
                return errors;
            },
            stockErrors () {
                const errors = [];
                if (!this.$v.formArticle.stock.$dirty) return errors;
                !this.$v.formArticle.stock.minValue && errors.push('Introduza valores não negativos');
                return errors;
            },
            minStockErrors (){
                const errors = [];
                if (!this.$v.formArticle.min_stock.$dirty) return errors;
                !this.$v.formArticle.min_stock.minValue && errors.push('Introduza valores não negativos');
                return errors;
            },
            descriptionErrors () {
                const errors = [];
                if (!this.$v.formArticle.description.$dirty) return errors;
                // !this.$v.name.decimal && errors.push('Name must be a number')
                !this.$v.formArticle.description.maxLength && errors.push('Máximo de 250 caracteres.');
                return errors;
            },
        },

        methods: {
            showSnackBar(message, color){
                this.snackbar = true;
                this.text = message;
                this.snackbar_color = color;
            },

            searchCompany: _.debounce((vm) => {
                try {
                    if (!vm.searchCompanyField) return;
                    vm.isLoading = true;

                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + vm.getToken;
                    Vue.axios.get('company/search/' + vm.searchCompanyField)
                        .then(response => {
                            vm.consoleLog(response);
                            if (!response.data.success) {
                                //do nothing
                                return;
                            }

                            vm.companies = response.data.response;

                        }).catch(error => {
                        // do nothing
                    }).finally(() => {
                        vm.isLoading = false
                    });
                }catch(e){
                    vm.consoleLog(e);
                }
            }, 700),

            getProperCompanyId(){
                // if(this.isLoggedUserSuperAdmin){
                //     this.consoleLog('Adding article: user is super admin, using this ID: '+this.formArticle.companies_id);
                //     return this.formArticle.companies_id;
                // }
                this.consoleLog('Adding article: user is NOT super admin, using this ID: '+this.loggedUser.group.company.id);
                return this.loggedUser.group.company.id;
            },

            addArticle(){
                // this.consoleLog('Companies_id: '+this.getProperCompanyId());
                try {
                    this.loading_modal = true;

                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.post('article', {
                        name: this.formArticle.name,
                        types_id: this.formArticle.types_id,
                        bar_code: this.formArticle.bar_code,
                        companies_id: this.getProperCompanyId(),
                        active_state: this.formArticle.active_state,
                        price: this.formArticle.price,
                        unity: this.formArticle.unity,
                        stock: this.formArticle.stock,
                        min_stock: this.formArticle.min_stock,
                        description: this.formArticle.description,

                        category_id: this.formArticle.category ? this.formArticle.category.id : '',
                        category_name: this.formArticle.category && this.formArticle.category.id ? this.formArticle.category.name : this.formArticle.category,
                        model: Model.ARTICLE,

                        subcategory_id: this.formArticle.subcategory ? this.formArticle.subcategory.id : '',
                        subcategory_name: this.formArticle.subcategory && this.formArticle.subcategory.id ? this.formArticle.subcategory.name : this.formArticle.subcategory,
                        subcategory_model: Model.ARTICLE,

                    })
                        .then(response => {
                            this.consoleLog(response);
                            if (!response.data.success) {
                                this.handleErrorCodeMessage(response.data);
                                this.loading = false;
                                return;
                            }

                            this.$emit('onFormArticleDone', response.data.response, '');
                            this.showSnackBar('Artigo adicionado com sucesso', 'success');
                            this.close();

                        }).catch(error => {
                            this.consoleLog(error);
                        }).finally(() => {
                            this.loading_modal = false;
                        });
                }catch (e) {
                    this.consoleLog(e);
                    this.showSnackBar('Ocorreu um erro ao adicionar artigo!!!', 'error');
                    this.loading_modal = false;
                }
            },

            updateArticle(){
                try{
                    if(this.selectedArticle === null) {
                        this.showSnackBar('Ocorreu um erro ao atualizar artigo', 'error');
                        return;
                    }

                    if(this.formArticle.category && this.formArticle.category.id){
                        this.consoleLog('articleId: '+this.formArticle.category.id);
                    }else{
                        this.consoleLog('article vvvv');
                        this.consoleLog(this.formArticle.category);
                    }

                    this.loading_modal = true;

                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                    Vue.axios.put('article/'+this.selectedArticle.id, {
                        name: this.formArticle.name,
                        types_id: this.formArticle.types_id,
                        bar_code: this.formArticle.bar_code,
                        companies_id: this.getProperCompanyId(),
                        active_state: this.formArticle.active_state,
                        price: this.formArticle.price,
                        unity: this.formArticle.unity,
                        stock: this.formArticle.stock,
                        min_stock: this.formArticle.min_stock,
                        description: this.formArticle.description,

                        category_id: this.formArticle.category ? this.formArticle.category.id : '',
                        category_name: this.formArticle.category && this.formArticle.category.id ? this.formArticle.category.name : this.formArticle.category,
                        model: Model.ARTICLE,

                        subcategory_id: this.formArticle.subcategory ? this.formArticle.subcategory.id : '',
                        subcategory_name: this.formArticle.subcategory && this.formArticle.subcategory.id ? this.formArticle.subcategory.name : this.formArticle.subcategory,
                        subcategory_model: Model.ARTICLE,


                    }).then(response => {
                        this.consoleLog(response);
                        if(!response.data.success){
                            this.handleErrorCodeMessage(response.data);
                            return;
                        }
                        this.setUpCategoryAndSubcategory(this);
                        this.$emit('onFormArticleDone');
                        this.showSnackBar('Artigo atualizado com sucesso', 'success');
                        this.consoleLog('=======----=');
                        this.close();

                    }).catch(error => {
                        this.consoleLog(error);
                    }).finally( ()=> {
                        this.loading_modal = false;
                    });
                }catch (e) {
                    this.showSnackBar('Ocorreu um erro ao atualizar empresa!', 'error');
                    this.loading_modal = false;
                }
            },

            save () {
                let vm = this;
                setTimeout(()=>{
                    if (vm.selectedArticle.id) {
                        vm.updateArticle();
                    } else {
                        vm.addArticle();
                    }
                }, 100);

            },

            isService(){
                return this.formArticle.types_id === Types.article.SERVICO;
            },

            onArticleTypeChanged(){
                if(this.isService()){
                    this.formArticle.stock = undefined;
                    this.formArticle.min_stock = undefined;
                    this.formArticle.unity = undefined;
                }
            },

            setUpCategoryAndSubcategory(){
                try {
                    for(let i=0; i<this.categories.length; i++){
                        if(this.categories[i].id === this.formArticle.category){
                            this.formArticle.category = this.categories[i];
                        }
                    }

                    for(let i=0; i<this.subcategories.length; i++){
                        if(this.subcategories[i].id === this.formArticle.subcategory){
                            this.formArticle.subcategory = this.subcategories[i];
                        }
                    }
                }catch (e) {
                    //do nothing
                }
            },

            onArticleFormOpened(){
                this.setUpCategoryAndSubcategory();
                if(this.selectedArticle && !this.selectedArticle.id) {
                    this.formArticle.active_state = 1;
                }
            },

            resetForm(){
                this.formArticle.name = '';
                this.formArticle.types_id = '';
                this.formArticle.price = '';
                this.formArticle.active_state = '';
                this.formArticle.stock = '';
                // this.formArticle.companies_id = '';
                this.formArticle.description = '';
            },

            close () {
                this.$v.$reset();
                this.resetForm();
                this.active_tab = 0;
                this.showArticleModal = false;
                setTimeout(() => {
                    this.loading = false;
                    this.selectedIndex = -1;
                    this.articleShow = false;
                    this.selectedArticle = null;
                }, 300)
            },

        }
    }
</script>

<style scoped>

</style>